export function keepIndex(src) {
  return Number(src.match(/(?=(\w+)\.\w{3,4}$).+/)[1]);
}
